import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=655c1786&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=655c1786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c1786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655c1786')) {
      api.createRecord('655c1786', component.options)
    } else {
      api.reload('655c1786', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=655c1786&scoped=true&", function () {
      api.rerender('655c1786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Terms.vue"
export default component.exports